import { render, staticRenderFns } from "./MarvelGrid.vue?vue&type=template&id=2a8e27e6&scoped=true"
import script from "./MarvelGrid.vue?vue&type=script&lang=js"
export * from "./MarvelGrid.vue?vue&type=script&lang=js"
import style0 from "./MarvelGrid.vue?vue&type=style&index=0&id=2a8e27e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e27e6",
  null
  
)

export default component.exports